<template>
  <div class="paycools-kyc-page">
    <section class="kyc-content">
      <!-- 标题区 -->
      <header class="kyc-header">
        <el-button type="text" style="padding:0;" @click="$emit('requestBack')">
          <svg-icon icon-class="back" class-name="kyc-back-icon" />
        </el-button>
        <h2 class="kyc-title">{{ $t('kyc.title') }}</h2>
      </header>

      <!-- 表单区 -->
      <el-form
        ref="companyForm"
        :model="form"
        :rules="companyRules"
        label-position="left"
        label-width="260px"
        class="kyc-form"
      >
        <div v-if="rejectionItems && rejectionItems.length" class="kyc-rejection-box" style="margin-bottom:16px;">
          <el-alert
            type="error"
            :title="$t('kyc.rejection_title')"
            :closable="false"
            show-icon
          >
            <div v-for="(item, index) in rejectionItems" :key="index" class="rejection-item">
              {{ index + 1 }}. {{ item }}
            </div>
          </el-alert>
        </div>
        <!-- Phone Number -->
        <el-form-item prop="contact_mobile" :label="$t('kyc.phone_number')">
          <el-input v-model="form.contact_mobile" :placeholder="$t('kyc.placeholder_enter_phone')" maxlength="14" />
        </el-form-item>

        <!-- Email -->
        <el-form-item prop="contact_email" :label="$t('kyc.email')">
          <el-input v-model="form.contact_email" :placeholder="$t('kyc.placeholder_enter_email')" maxlength="100" />
        </el-form-item>

        <!-- Full Name -->
        <el-form-item prop="contact_name" :label="$t('kyc.full_name')">
          <el-input v-model="form.contact_name" :placeholder="$t('kyc.placeholder_enter_name')" maxlength="100" />
        </el-form-item>

        <!-- Company Type -->
        <el-form-item prop="type_of_business" :label="$t('kyc.company_info_company_type')">
          <el-select v-model="form.type_of_business" :placeholder="$t('components.select')">
            <el-option
              v-for="(item,index) in companyTypeOptions"
              :key="index"
              :label="language === 'zh' ? item.cn_name : item.en_name"
              :value="item.nm_code"
            />
          </el-select>
        </el-form-item>

        <!-- Type of Business Defined (当选择其他类型时显示) -->
        <el-form-item v-if="form.type_of_business === 99" prop="type_of_business_defined">
          <el-input
            v-model="form.type_of_business_defined"
            :placeholder="language === 'zh' ? '其他业务类型' : 'Other'"
            maxlength="100"
            clearable
          />
        </el-form-item>

        <!-- Exchange Name (当companyNature === 4时显示) -->
        <el-form-item v-if="form.type_of_business === 4" prop="exchange_name" :label="$t('kyc.company_info_exchange_name')">
          <el-input
            v-model="form.exchange_name"
            :placeholder="$t('kyc.placeholder_enter_exchange_name')"
            maxlength="100"
            clearable
          />
        </el-form-item>

        <!-- Stock Code (当companyNature === 4时显示) -->
        <el-form-item v-if="form.type_of_business === 4" prop="stock_code" :label="$t('kyc.company_info_stock_code')">
          <el-input
            v-model="form.stock_code"
            :placeholder="$t('kyc.placeholder_enter_stock_code')"
            maxlength="100"
            clearable
          />
        </el-form-item>

        <!-- Company Name -->
        <el-form-item prop="merchant_name" :label="$t('kyc.company_info_legal_name_en')">
          <el-input v-model="form.merchant_name" :placeholder="$t('kyc.company_info_placeholder_enter_legal_name')" maxlength="100" />
        </el-form-item>

        <!-- Company Registration Number -->
        <el-form-item prop="coi_number" :label="$t('kyc.company_info_registration_number')">
          <el-input
            v-model="form.coi_number"
            :placeholder="$t('kyc.company_info_placeholder_enter_registration_number')"
            maxlength="100"
          />
        </el-form-item>

        <!-- Date of Incorporation -->
        <el-form-item prop="company_registration_validity" :label="$t('kyc.company_info_date_of_incorporation')">
          <el-date-picker
            v-model="form.company_registration_validity"
            style="width: 100%"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('components.start_date')"
            :end-placeholder="$t('components.end_date')"
          />
        </el-form-item>

        <!-- Tax Identification Number -->
        <el-form-item prop="tax_number" :label="$t('kyc.company_info_tax_id')">
          <el-input
            v-model="form.tax_number"
            :placeholder="$t('kyc.company_info_placeholder_enter_tax_id')"
            maxlength="100"
            @focus="focusTaxNum"
            @input="changeTaxNum"
            @blur="blurTaxNum"
          />
        </el-form-item>

        <!-- Business Address -->
        <el-form-item prop="business_operating_address.address_str" :label="$t('kyc.company_info_registration_address')">
          <el-input
            v-model="form.business_operating_address.address_str"
            :placeholder="$t('kyc.company_info_placeholder_enter_registration_address')"
            maxlength="500"
          />
        </el-form-item>

        <!-- Brand Name / Trade Name -->
        <el-form-item prop="trade_name" :label="$t('kyc.company_info_brand_name')">
          <el-input
            v-model="form.trade_name"
            :placeholder="$t('kyc.company_info_placeholder_enter_brand_name')"
            maxlength="100"
          />
        </el-form-item>

        <!-- Business website -->
        <el-form-item prop="business_web_site" :label="$t('kyc.company_info_business_website')">
          <el-input
            v-model="form.business_web_site"
            :placeholder="$t('kyc.placeholder_enter_website')"
            maxlength="500"
          />
        </el-form-item>

        <!-- Store Photo -->
        <el-form-item prop="office_premises_photo" :label="$t('kyc.store_photo')">
          <UpdateFile
            ref="office_premises_photo"
            v-model="form.office_premises_photo"
            type="office_premises_photo"
            :file-list="fileList"
            :uploading="uploading"
            :remove-files="removeFiles"
            :uploading-progress="uploadingProgress"
            @changeFileList="changeFileList"
            @changeUploading="changeUploading"
            @changeUploadingProgress="changeUploadingProgress"
            @changeRemoveFiles="changeRemoveFiles"
          />
        </el-form-item>

        <!-- Merchant Category Code (MCC) -->
        <el-form-item prop="merchant_category" :label="$t('kyc.company_info_mcc')">
          <ScopeSelect
            ref="merchant_category"
            :value="form.merchant_category"
            :cn-name="'scope_cn_name'"
            :en-name="'scope_en_name'"
            style="width: 100%;"
            @updateValue="form.merchant_category = $event"
          />
        </el-form-item>

        <!-- Total Amount of Monthly Transaction -->
        <el-form-item prop="turnover" :label="$t('kyc.company_info_monthly_transaction')">
          <el-select v-model="form.turnover" :placeholder="$t('components.select')">
            <el-option
              v-for="opt in turnoverOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div class="kyc-footer">
        <el-button class="kyc-draft-btn" :disabled="isSubmitting" @click="handleSave">{{ $t('kyc.save_as_draft') }}</el-button>
        <el-button type="primary" class="kyc-next-btn" :disabled="isSubmitting" @click="handleNext">{{ $t('kyc.next_step') }}</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import { getCurrencyOptions } from '@/maps/kyc'
import { updateCompanyBasicInfo } from '@/api/kyc/kyc'
const fileType = {
  office_premises_photo: 32 // 办公室照片
}
export default {
  name: 'PaycoolsKycCompanyInfo',
  components: {
    UpdateFile: () => import('@/views/paycools/kyc/UpdateFile'),
    SvgIcon: () => import('@/components/SvgIcon')
  },
  props: {
    kycData: {
      type: Object,
      default: null
    },
    companyFiles: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      const strValue = String(value)
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(strValue)) {
        return callback(new Error(this.$t('kyc.validation_email_invalid')))
      }
      return callback()
    }
    const checkoutMobile = (rule, value, callback) => {
      const strValue = String(value)
      if (value && !/^08\d{8,12}$/.test(strValue)) {
        return callback(new Error(this.$t('kyc.validation_phone_invalid')))
      }
      return callback()
    }
    const validateBusinessWebSite = (rule, value, callback) => {
      const strValue = String(value)
      if (value && !/^(http|https):\/\/.*$/.test(strValue)) {
        return callback(new Error(this.$t('kyc.validation_business_website_format')))
      }
      return callback()
    }
    return {
      fileList: {
        office_premises_photo: [] // 办公室照片
      },
      uploading: {
        office_premises_photo: false // 办公室照片
      },
      uploadingProgress: {
        office_premises_photo: 0 // 办公室照片
      },
      fieldRequireTips: {
        office_premises_photo: 'Store Photo' // 办公室照片
      },
      form: {
        contact_mobile: '',
        contact_email: '',
        contact_name: '',
        type_of_business: '',
        type_of_business_defined: '',
        exchange_name: '',
        stock_code: '',
        merchant_name: '',
        coi_number: '',
        company_registration_validity: '',
        tax_number: '',
        business_operating_address: { address_str: '' },
        trade_name: '',
        business_web_site: '',
        office_premises_photo: null,
        merchant_category: '',
        business_scope: '',
        turnover: ''
      },
      companyRules: {
        contact_mobile: [
          { required: true, message: this.$t('kyc.validation_phone_required'), trigger: ['blur', 'change'] },
          { validator: checkoutMobile, trigger: ['blur', 'change'] }
        ],
        contact_email: [
          { required: true, message: this.$t('kyc.validation_email_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] },
          { validator: validateEmail, trigger: ['blur', 'change'] }
        ],
        contact_name: [
          { required: true, message: this.$t('kyc.validation_full_name_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        type_of_business: [{ required: true, message: this.$t('kyc.validation_company_type_required'), trigger: ['blur', 'change'] }],
        type_of_business_defined: [
          { required: true, message: this.$t('kyc.validation_type_of_business_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        exchange_name: [
          { required: true, message: this.$t('kyc.validation_exchange_name_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        stock_code: [
          { required: true, message: this.$t('kyc.validation_stock_code_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        merchant_name: [
          { required: true, message: this.$t('kyc.validation_company_name_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        coi_number: [
          { required: true, message: this.$t('kyc.validation_company_registration_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        company_registration_validity: [{ required: true, message: this.$t('kyc.validation_date_of_incorporation_required'), trigger: ['change'] }],
        tax_number: [
          { required: true, message: this.$t('kyc.validation_tax_id_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        'business_operating_address.address_str': [
          { required: true, message: this.$t('kyc.validation_business_address_required'), trigger: ['blur', 'change'] },
          { max: 500, message: this.$t('kyc.validation_length_500'), trigger: ['blur', 'change'] }
        ],
        trade_name: [
          { required: true, message: this.$t('kyc.validation_brand_name_required'), trigger: ['blur', 'change'] },
          { max: 100, message: this.$t('kyc.validation_length_100'), trigger: ['blur', 'change'] }
        ],
        business_web_site: [
          { required: true, message: this.$t('kyc.validation_business_website_required'), trigger: ['blur', 'change'] },
          { max: 500, message: this.$t('kyc.validation_length_500'), trigger: ['blur', 'change'] },
          { validator: validateBusinessWebSite, trigger: ['blur', 'change'] }
        ],
        office_premises_photo: [{ required: true, message: this.$t('kyc.validation_store_photo_required'), trigger: ['change'] }],
        merchant_category: [{ required: true, message: this.$t('kyc.validation_mcc_required'), trigger: ['blur', 'change'] }],
        business_scope: [{ required: true, message: this.$t('kyc.validation_business_scope_required'), trigger: ['blur', 'change'] }],
        turnover: [{ required: true, message: this.$t('kyc.validation_monthly_transaction_required'), trigger: ['blur', 'change'] }]
      },
      removeFiles: [],
      localSubmitting: false
    }
  },
  computed: {
    isSubmitting() {
      return this.submitting || this.localSubmitting
    },
    companyTypeOptions() {
      return this.$store.getters.merchantCategoryArr
    },
    language() {
      return this.$store.getters.language
    },
    currencyOptions() {
      return getCurrencyOptions()
    },
    turnoverOptions() {
      return [
        { label: 'IDR 1 - IDR 100 Million(Small)', value: 1 },
        { label: 'IDR 100 Million - IDR 1,000 Million (SME)', value: 2 },
        { label: 'IDR 1,000 Million - IDR 5,000 Million (Medium)', value: 3 },
        { label: 'IDR 5,000 Million - IDR 25,000 Million (Large)', value: 4 },
        { label: 'IDR 25,000 Million+ (Super)', value: 5 }
      ]
    },
    rejectionItems() {
      const audit = this.kycData && this.kycData.audit_info
      if (!audit || audit.kyc_status !== 4) return []
      return (audit.audit_back_list || []).map(item => item.back_content).filter(Boolean).slice(0, 3)
    },
    rejectionMessage() {
      const audit = this.kycData && this.kycData.audit_info
      if (!audit || audit.kyc_status !== 4) return ''
      const first = (audit.audit_back_list || [])[0]
      return (first && first.back_content) ? first.back_content : ''
    },
    formattedRejectionMessage() {
      const msg = this.rejectionMessage || ''
      // escape HTML
      const esc = (str) => String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      return esc(msg).replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>')
    }
  },
  watch: {
    kycData: {
      handler(newData) {
        if (newData && (newData.company_basic_info || newData.company_business_info)) {
          this.populateFormData(newData)
        }
      },
      immediate: true
    },
    form: {
      deep: true,
      handler() {
        this.$emit('markChanged')
      }
    }
  },
  methods: {
    focusTaxNum() {
      this.cacheTin = this.form.tax_number.trim()
    },
    changeTaxNum() {
      const tax_num = this.form.tax_number.trim()
      const length = this.form.tax_number.trim().length
      // 删除的时候不做处理
      const isDelete = this.cacheTin.length > length
      // 处理添加操作
      if (!isDelete && [3, 7, 11].includes(length)) {
        if (/^\d{3}$|(^\d{3}-\d{3}$)|(^\d{3}-\d{3}-\d{3}$)/.test(tax_num)) {
          this.form.tax_number = this.form.tax_number + '-'
        }
      } else if (!isDelete && [4, 8, 12].includes(length)) {
        const strLast = tax_num.slice(-1)
        const str = tax_num.substring(0, length - 1)
        if (/^\d{3}$|(^\d{3}-\d{3}$)|(^\d{3}-\d{3}-\d{3}$)/.test(str)) {
          this.form.tax_number = str + '-' + strLast
        }
      }
      this.cacheTin = this.form.tax_number
    },
    blurTaxNum() {
      const tax_num = this.form.tax_number.trim()
      const length = this.form.tax_number.trim().length
      if (tax_num.endsWith('-')) {
        const value = tax_num.substring(0, length - 1)
        this.form.tax_number = value
      }
    },
    // file upload handlers (for UpdateFile) - unify with CompanyDocument style
    changeFileList(config) {
      // handle indexed types like "0___bankImageList" with existing logic
      if (config.type && config.type.includes('___')) {
        let type = config.type
        const keyArr = type.split('___')
        const index = keyArr[0]
        type = keyArr[1]

        if (config.filter) {
          const imgList = this.form[index][type]
          const { uid } = config.file
          this.form[index][type] = imgList.filter(item => item.uid !== uid)
          return
        }

        if (config.push) {
          const { name, url } = config.file
          this.form[index][type].push({ name, url, content: config.resData, content_oss_url: config.content_oss_url })
          return
        }

        this.form[index][type] = config.typeFileList
        return
      }

      // non-indexed types: use unified fileList + store absolute URL to form
      if (config.push) {
        const { name } = config.file
        if (!this.fileList[config.type]) this.$set(this.fileList, config.type, [])
        this.fileList[config.type].push({
          name: name || (config.file && config.file.name),
          url: config.content_oss_url,
          content: config.resData,
          content_oss_url: config.content_oss_url
        })
        this.$set(this.form, config.type, config.resData)
        this.$refs['companyForm'] && this.$refs['companyForm'].clearValidate(config.type)
        return
      } else if (config.delete && config.typeFileList.length === 0) {
        this.$set(this.form, config.type, null)
        this.$refs['companyForm'] && this.$refs['companyForm'].validateField(config.type)
      }
      const normalized = (config.typeFileList || []).map(item => ({
        name: item.name,
        url: item.url,
        content: item.content,
        content_oss_url: item.content_oss_url
      }))
      this.$set(this.fileList, config.type, normalized)
    },
    changeUploading(config) {
      this.$set(this.uploading, config.type, config.value)
    },
    changeUploadingProgress(config) {
      this.$set(this.uploadingProgress, config.type, config.value)
    },
    changeRemoveFiles(config) {
      if (config.push) {
        const { uid } = config.file
        this.removeFiles.push(uid)
        return
      }
    },
    async handleSave() {
      if (this.localSubmitting) return
      this.localSubmitting = true
      try {
        await this.saveDraft()
        this.$message.success(this.$t('kyc.save_draft_success'))
      } catch (error) {
        // 错误已在 saveDraft 中处理，这里不需要额外处理
      } finally {
        this.localSubmitting = false
      }
    },
    async saveDraft() {
      return new Promise((resolve, reject) => {
        this.$refs['companyForm'].validate((valid, invalidateData) => {
          if (!valid) {
            // 表单验证失败，不在此处弹提示，由父组件统一处理
            reject(new Error('表单验证失败'))
            return
          }
          this.$emit('resetChanged')
          // 验证通过后执行异步保存逻辑
          this.performSave().then(resolve).catch(reject)
        })
      })
    },
    async performSave() {
      const formData = this.form || {}
      // separate fields for mch_business_info_req and mch_basic_info_req
      const {
        coi_number,
        company_registration_validity,
        turnover,
        business_web_site,
        business_scope,
        business_operating_address,
        tax_number,
        ...basicFormData
      } = formData

      // mch_basic_info_req fields
      const basicParams = { ...basicFormData }

      // prune empty values from basic params
      Object.keys(basicParams).forEach(key => {
        const val = basicParams[key]
        if (val === undefined || val === '') delete basicParams[key]
      })

      if (tax_number) {
        basicParams.tax_info_req = { tin: tax_number }
      }

      if (business_operating_address && business_operating_address.address_str) {
        basicParams.business_operating_address = { address_str: business_operating_address.address_str }
      }

      // mch_business_info_req fields
      const businessInfo = {
        business_scope
      }

      // Add registration validity at top level (not in company_files)
      if (company_registration_validity && company_registration_validity.length > 0) {
        businessInfo.validity_date = {
          type: 3,
          validity_start: company_registration_validity[0],
          validity_end: company_registration_validity[1] || ''
        }
      }

      if (coi_number) businessInfo.coi_number = coi_number
      if (turnover) businessInfo.turnover = turnover
      if (business_web_site) businessInfo.business_web_site = business_web_site
      const companyFiles = []
      this.fileList['office_premises_photo'].forEach(item => {
        companyFiles.push({
          type: 32,
          content: item.content,
          name: item.name
        })
      })
      businessInfo.company_files = companyFiles

      const payload = {
        mch_basic_info_req: basicParams,
        mch_business_info_req: businessInfo
      }

      const result = await updateCompanyBasicInfo(payload)
      this.$emit('firstStepSaved')
      this.$emit('saved')
      return result
    },
    async handleNext() {
      if (this.localSubmitting) return
      this.localSubmitting = true
      try {
        await this.saveDraft()
        this.$emit('next')
      } catch (error) {
        // 错误已在 saveDraft 中处理，这里不需要额外处理
      } finally {
        this.localSubmitting = false
      }
    },
    populateFormData(data) {
      if (!data) return

      // Extract data from nested structure
      const companyBasicInfo = data.company_basic_info || {}
      const companyBusinessInfo = data.company_business_info || {}

      // Start with shallow merge of available info
      const mergedData = {
        ...companyBasicInfo,
        ...companyBusinessInfo
      }

      // remove null/undefined keys so we don't overwrite defaults (e.g., business_operating_address)
      Object.keys(mergedData).forEach(k => {
        if (mergedData[k] === null || mergedData[k] === undefined) {
          delete mergedData[k]
        }
      })

      // Process company files - find office premises photo (type: 32)
      // Use the unified companyFiles prop instead of data.company_files
      const companyFiles = this.companyFiles || []

      // Remove nested objects that we'll handle explicitly
      delete mergedData.tax_info
      delete mergedData.validity_date

      if (companyBusinessInfo.validity_date) {
        const validity_date = companyBusinessInfo.validity_date
        mergedData.company_registration_validity = [
          validity_date.validity_start,
          validity_date.validity_end
        ]
      }

      // Conditionally add flattened fields only if they exist
      if (companyBasicInfo && companyBasicInfo.tax_info && companyBasicInfo.tax_info.tin) {
        mergedData.tax_number = companyBasicInfo.tax_info.tin
      }

      if (companyBusinessInfo && companyBusinessInfo.business_scope) {
        mergedData.business_scope = companyBusinessInfo.business_scope
      }

      // Handle merchant_category (MCC) - ensure it's the correct type for ScopeSelect
      if (companyBasicInfo && companyBasicInfo.merchant_category !== undefined && companyBasicInfo.merchant_category !== null) {
        // Convert to string to ensure proper matching with ScopeSelect options
        mergedData.merchant_category = companyBasicInfo.merchant_category
      }

      // Process business operating address only if present
      if (companyBasicInfo && companyBasicInfo.business_operating_address && (companyBasicInfo.business_operating_address.address_str || companyBasicInfo.business_operating_address.address)) {
        mergedData.business_operating_address = { address_str: companyBasicInfo.business_operating_address.address_str || companyBasicInfo.business_operating_address.address || '' }
      }

      // Set form data
      this.form = { ...this.form, ...mergedData }

      this.fileList = {
        office_premises_photo: [] // 办公室照片
      }

      const typeMapping = {
        32: 'office_premises_photo' // 办公室照片
      }
      companyFiles.forEach(file => {
        const formKey = typeMapping[file.type]
        if (formKey) {
          this.fileList[formKey].push({
            name: file.name || `${formKey}.pdf`,
            url: file.content_oss_url || file.content,
            content: file.content,
            content_oss_url: file.content_oss_url || file.content
          })
          this.$set(this.form, formKey, file.content)
          this.$refs['form'] && this.$refs['form'].clearValidate(formKey)
        }
      })
      // company info form populated
    }
  }
}
</script>

<style lang="scss" scoped>
.paycools-kyc-page {
  display: flex;
  align-items: stretch;
  background-color: #f5f7fb;
  min-height: calc(100vh - 80px);
  box-sizing: border-box;
}

.kyc-sidebar {
  width: 240px;
  background-color: #f7f8fc;
  border-radius: 8px;
  padding: 24px 0;
  box-shadow: 0 0 0 1px #edf0f7;
}

.kyc-step-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.kyc-step-item {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  font-size: 14px;
  color: #7b8192;
  cursor: default;
}

.kyc-step-item.is-active {
  background-color: #ffffff;
  color: #2f3a60;
  font-weight: 600;
  border-left: 3px solid #3b82f6;
}

.kyc-step-index {
  margin-right: 8px;
}

.kyc-step-label {
  flex: 1;
}

.kyc-content {
  flex: 1;
  margin-left: 32px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 32px 40px 40px;
  box-shadow: 0 8px 20px rgba(15, 35, 95, 0.04);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.kyc-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;
}

.kyc-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
}

.kyc-subtitle {
  margin: 8px 0 20px;
  font-size: 14px;
  color: #6b7280;
}

.kyc-business-type {
  display: flex;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #c7d2fe;
  max-width: 480px;
}

.kyc-business-type-btn {
  flex: 1;
  border: none;
  border-radius: 0;
  font-weight: 500;
}

.kyc-business-type-btn.is-active {
  background-color: #3b82f6;
  color: #ffffff;
}

.kyc-business-type-btn.is-ghost {
  background-color: #ffffff;
  color: #374151;
}

.kyc-form {
  max-width: 920px;
  flex: 1;
}

.kyc-inline-date-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.kyc-radio-group {
  display: inline-flex;
  align-items: center;
  gap: 32px;
}

.kyc-upload-single {
  width: 100%;
  max-width: 600px;
}

.kyc-upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  background-color: #fafafa;
}

.kyc-upload-icon {
  font-size: 32px;
  color: #9ca3af;
  margin-bottom: 12px;
  font-weight: 300;
}

.kyc-upload-main-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.kyc-upload-tip {
  font-size: 12px;
  color: #9ca3af;
}

.kyc-footer {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 16px;
  align-items: center;
}

.kyc-draft-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  background-color: #ffffff;
  color: #3b82f6;
  border: 1px solid #3b82f6;
  border-radius: 6px;
}

.kyc-next-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  background-color: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 6px;
}

.kyc-submit-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  background-color: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 6px;
}
</style>

<style lang="scss" scoped>
.rejection-item {
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>

